import { useContext } from "react";
import { ApiContext } from "../../contexts/ApiContext";
import { QueryCallbacks } from "../../shared/interfaces/ReactQuery";
import { useQuery } from "react-query";
import { PagedData } from "../../shared/interfaces/ResultsAPIInterfaces";
import { DataTablePFSEvent } from "primereact/datatable";
import { GeneratedReport } from "../../shared/interfaces/GeneratedReport";

export function usePagedGeneratedReportsByReportDocumentId(
  lazyState: DataTablePFSEvent,
  reportDocumentId: number,
  customerId: number,
  companyId: number,
  siteId: number,
  callbacks?: QueryCallbacks<PagedData<GeneratedReport[]>>,
) {
  const apiContext = useContext(ApiContext);

  return useQuery({
    queryKey: ["pagedGeneratedReportsByReportDocumentId", lazyState, reportDocumentId, customerId, companyId, siteId],
    queryFn: async () => {
      if (lazyState)
        return await apiContext.utp2ReportsAPIs.getPagedGeneratedReportsByReportDocumentId(
          lazyState,
          reportDocumentId,
          customerId,
          companyId,
          siteId,
        );
    },
    onSuccess: callbacks?.onSuccess,
    onError: callbacks?.onError,
  });
}
